/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { WatcherDto } from './WatcherDto';
import {
    WatcherDtoFromJSON,
    WatcherDtoFromJSONTyped,
    WatcherDtoToJSON,
    WatcherDtoToJSONTyped,
} from './WatcherDto';
import type { SimulationStatus } from './SimulationStatus';
import {
    SimulationStatusFromJSON,
    SimulationStatusFromJSONTyped,
    SimulationStatusToJSON,
    SimulationStatusToJSONTyped,
} from './SimulationStatus';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';

/**
 * 
 * @export
 * @interface SimulationListEntryDto
 */
export interface SimulationListEntryDto {
    /**
     * 
     * @type {number}
     * @memberof SimulationListEntryDto
     */
    simulationId: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationListEntryDto
     */
    simulationName: string;
    /**
     * 
     * @type {UserDto}
     * @memberof SimulationListEntryDto
     */
    createdBy: UserDto;
    /**
     * 
     * @type {UserDto}
     * @memberof SimulationListEntryDto
     */
    assignedTo: UserDto;
    /**
     * 
     * @type {Date}
     * @memberof SimulationListEntryDto
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationListEntryDto
     */
    year: number;
    /**
     * 
     * @type {Date}
     * @memberof SimulationListEntryDto
     */
    planningDate: Date;
    /**
     * 
     * @type {string}
     * @memberof SimulationListEntryDto
     */
    marketGroup: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimulationListEntryDto
     */
    subMarketGroups: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimulationListEntryDto
     */
    priceUnitIds: Array<number>;
    /**
     * 
     * @type {SimulationStatus}
     * @memberof SimulationListEntryDto
     */
    status: SimulationStatus;
    /**
     * 
     * @type {number}
     * @memberof SimulationListEntryDto
     */
    watcherCount?: number;
    /**
     * 
     * @type {Array<WatcherDto>}
     * @memberof SimulationListEntryDto
     */
    watchers?: Array<WatcherDto>;
}



/**
 * Check if a given object implements the SimulationListEntryDto interface.
 */
export function instanceOfSimulationListEntryDto(value: object): value is SimulationListEntryDto {
    if (!('simulationId' in value) || value['simulationId'] === undefined) return false;
    if (!('simulationName' in value) || value['simulationName'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('assignedTo' in value) || value['assignedTo'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('planningDate' in value) || value['planningDate'] === undefined) return false;
    if (!('marketGroup' in value) || value['marketGroup'] === undefined) return false;
    if (!('subMarketGroups' in value) || value['subMarketGroups'] === undefined) return false;
    if (!('priceUnitIds' in value) || value['priceUnitIds'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function SimulationListEntryDtoFromJSON(json: any): SimulationListEntryDto {
    return SimulationListEntryDtoFromJSONTyped(json, false);
}

export function SimulationListEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationListEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'simulationId': json['simulationId'],
        'simulationName': json['simulationName'],
        'createdBy': UserDtoFromJSON(json['createdBy']),
        'assignedTo': UserDtoFromJSON(json['assignedTo']),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'year': json['year'],
        'planningDate': (new Date(json['planningDate'])),
        'marketGroup': json['marketGroup'],
        'subMarketGroups': json['subMarketGroups'],
        'priceUnitIds': json['priceUnitIds'],
        'status': SimulationStatusFromJSON(json['status']),
        'watcherCount': json['watcherCount'] == null ? undefined : json['watcherCount'],
        'watchers': json['watchers'] == null ? undefined : ((json['watchers'] as Array<any>).map(WatcherDtoFromJSON)),
    };
}

export function SimulationListEntryDtoToJSON(json: any): SimulationListEntryDto {
    return SimulationListEntryDtoToJSONTyped(json, false);
}

export function SimulationListEntryDtoToJSONTyped(value?: SimulationListEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'simulationId': value['simulationId'],
        'simulationName': value['simulationName'],
        'createdBy': UserDtoToJSON(value['createdBy']),
        'assignedTo': UserDtoToJSON(value['assignedTo']),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'year': value['year'],
        'planningDate': (formatDateOnly(value['planningDate'])),
        'marketGroup': value['marketGroup'],
        'subMarketGroups': value['subMarketGroups'],
        'priceUnitIds': value['priceUnitIds'],
        'status': SimulationStatusToJSON(value['status']),
        'watcherCount': value['watcherCount'],
        'watchers': value['watchers'] == null ? undefined : ((value['watchers'] as Array<any>).map(WatcherDtoToJSON)),
    };
}

